import { Loader } from '@mantine/core'

const Loading = () => {
  return (
    <>
      <Loader color="blue" size="xl" type="dots" />
    </>
  )
}

export default Loading
